import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  seamlessImmutableReconciler,
  seamlessImmutableTransformCreator,
} from 'redux-persist-seamless-immutable';
import createSagaMiddleware from 'redux-saga';
// import { find } from 'lodash';
// import Config from '../conf';

const getSagaMiddleware = () => createSagaMiddleware();

// const SAGA_LOGGING_BLACKLIST = [
//   'EFFECT_TRIGGERED',
//   'EFFECT_RESOLVED',
//   'EFFECT_REJECTED',
// ];
const transformerConfig = {
  blacklistPerReducer: {
    application: ['fetching', 'error', 'formErrors', 'page'],
    configs: ['fetching', 'error'],
    login: [
      'fetching',
      'authenticating',
      'error',
      'loadingSession',
      'password',
      'showEmailError',
      'showPasswordError',
    ],
  },
};

const persistConfig = {
  timeout: 10000,
  key: 'root',
  stateReconciler: seamlessImmutableReconciler,
  storage,
  blacklist: [
    'resetPassword',
    'changePassword',
    'signup',
    'payment',
    'activation',
    'declaration',
    'requesetResetPassword',
  ],
  transforms: [seamlessImmutableTransformCreator(transformerConfig)],
};

// const getLoggerMiddleware = () => {
//   // silence these saga-based messages
//   const Logger = require('redux-logger');
//   return Logger.createLogger({
//     predicate: (_, { type }) =>
//       Config.reduxLogging && !find(SAGA_LOGGING_BLACKLIST, type),
//   });
// };

// create the store
export default (rootReducer, rootSaga) => {
  const middleware = [];
  const enhancers = [];

  const sagaMiddleware = getSagaMiddleware();
  middleware.push(sagaMiddleware);

  // if (Config.dev) {
  //   middleware.push(getLoggerMiddleware());
  // }

  enhancers.push(applyMiddleware(...middleware));

  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const store = createStore(
    persistedReducer,
    composeWithDevTools(...enhancers)
  );
  const persistor = persistStore(store);

  // kick off root saga
  sagaMiddleware.run(rootSaga);

  return { store, persistor };
};



// WEBPACK FOOTER //
// ./src/state/configureStore.js